import React from 'react';
import { Route, Routes, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

import Tree from './components/Tree';
import OrnamentForm from './components/OrnamentForm';
import Navbar from './components/Navbar';
import LandingPage from './components/LandingPage';
import Footer from "./components/Footer"; // Import the Footer component
import Notes from './components/Notes';

import './App.css';
//import 'bootstrap/dist/css/bootstrap.min.css';


function App() {
    const location = useLocation(); // Get current location

    return (
            <div>
                {/*<nav>
                    <Link to="/">Home</Link>
                    <Link to="/add-ornament">Add Ornament</Link>
                </nav>*/}
                {location.pathname !== "/" && <Navbar />}
                <Routes>
                    <Route path="/" element={<LandingPage />} /> {/* Landing Page Route */}
                    <Route path="/notes" element={<Notes />} />
                    <Route path="/tree" element={<Tree />} />
                    <Route path="/add-ornament" element={<OrnamentFormPage />} />
                </Routes>
                <Footer /> 
            </div>
    );
}

function OrnamentFormPage() {
    const navigate = useNavigate();

    const handleSubmit = (data) => {
        axios.post("/api/ornaments/", data)
            .then(() => {
                alert("Ornament added!");
                navigate("/"); // Navigate back to the home page
            })
            .catch((error) => console.error("Error adding ornament:", error));
    };

    return (
        <div>
            <h2>Add Ornament</h2>
            <OrnamentForm onSubmit={handleSubmit} />
        </div>
    );
}

export default App;
